/** Stable destination keys for settings pages opened as workspace tabs. */
export const WORKSPACE_SETTINGS_DESTINATION = {
  appConfig: 'Org & Site App Config',
  manageUsers: 'Manage Users',
  managePermissions: 'Manage Permissions',
  manageAccess: 'Manage Access',
  healthCheck: 'Health Check',
  manageExtensions: 'Manage Extensions',
} as const
